import React, { useState, useRef, useEffect } from "react";
import { Card, Input, Select, Button, Modal } from "../../../../../common";
import { geoNames } from "../../../../../../utils/countriesGeonames";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { useSelector } from "react-redux";
import {
  useCreateOwnershipIndividualMutation,
  useCreateOwnershipMutation,
  useCreateOwnershipCompanyMutation,
  useUpdateOwnershipIndividualMutation,
  useCreateOwnershipCompanyDetailsMutation,
  useUpdateOwnershipCompanyDetailsMutation,
  useCreateOwnershipCompanyDetailsDraftMutation,
  useCreateOwnershipIndividualDraftMutation,
  useUpdateOwnershipIndividualDraftMutation,
  useUpdateOwnershipCompanyDetailsDraftMutation,
  useCreateCompanyMutation
} from "../../../../../../store/Company/companyApiSlice";
import { isVerified } from "../../../../../../utils/Helper";
import { getCountryCode } from "../../../../../../utils/countriesState";

export const AddNewOwner = ({ indOwnership, modalHandle, totalPercentage, onSearch, showForm, selectedCompany, setSelectedCompany, prevtype, previsousCountry, previsousShare, refetch, compRefetch, dataChanged, setDataChanged }) => {
  const [verified, setVerified] = useState(false);
  const [type, setType] = useState(selectedCompany ? "company" : "individual");
  const [countries, setCountries] = useState(getCountryCode());
  const [selectedCountry, setSelectedCountry] = useState(previsousCountry || selectedCompany?.country || selectedCompany?.country_code || "");
  const nameRef = useRef();
  const shareRef = useRef();
  const [modalOpen, setModalOpen] = useState(false);
  const companyRef = useRef();
  const [CompanyOwnership, setCompanyOwnership] = useState("");
  const [selectedOwnershipCompany, setSelectedOwnershipCompany] = useState("");
  const [createCompany, { isLoading: companyCreating }] = useCreateCompanyMutation();

  const [nameError, setNameError] = useState("");
  const [companyRefError, setCompanyRefError] = useState("");

  const [countryError, setCountryError] = useState("");
  const [shareError, setShareError] = useState("");

  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);

  const [individualOwnership, { isLoading }] =
    useCreateOwnershipIndividualMutation();
  const [createOwnershipCompanyDetailsMutation, { isLoading: companyLoading }] =
    useCreateOwnershipCompanyDetailsMutation();
  const [createOwnership] = useCreateOwnershipMutation();
  const [ownershipCompany] = useCreateOwnershipCompanyMutation();
  const [updateOwnershipIndividual, { isLoading: isUpdating }] =
    useUpdateOwnershipIndividualMutation();
  const [updateOwnershipCompanyDetails, { isLoading: comUpdating }] =
    useUpdateOwnershipCompanyDetailsMutation();
  const [createOwnershipIndividualDraft, { isLoading: individualDrafting }] = useCreateOwnershipIndividualDraftMutation();
  const [createOwnershipCompanyDetailsDraft, { isLoading: companyDrafting }] = useCreateOwnershipCompanyDetailsDraftMutation();
  const [updateOwnershipIndividualDraft] = useUpdateOwnershipIndividualDraftMutation()
  const [updateOwnershipCompanyDetailsDraft] = useUpdateOwnershipCompanyDetailsDraftMutation();


  let ind_id =
    currentEditingCompany?.ownershipCompany && currentEditingCompany?.ownershipCompany[1]?.ownershipID?.ownership_indID
      ?.ownership_indID;

  const handleTypeChange = (e) => {
    setType(e.target.value);
    setSelectedCountry(null);
  };
  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };
  useEffect(() => {
    if (previsousShare) {
      shareRef.current.value = previsousShare || "";

    }
    if (indOwnership) {
      setSelectedCountry(indOwnership.nationality || "");
      setType(indOwnership.type || "");
      nameRef.current.value =
        indOwnership.name || indOwnership.company_name || "";
      shareRef.current.value = indOwnership.percentage_of_shares_held || "";
    }
  }, [indOwnership, previsousShare]);

  const reset = () => {
    setSelectedCompany(null);
    nameRef.current && (nameRef.current.value = "");
    shareRef.current && (shareRef.current.value = "");
    companyRef.current && (companyRef.current.value = "");
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setModalOpen(true);
    const newErrors = {};
    if (type === "individual") {
      if (type === "individual" && nameRef.current.value.trim() === "") {
        newErrors.name = "Name is required.";
      }
    }
    if (!indOwnership && type === 'company') {
      if (companyRef?.current?.value.trim() === "") {
        newErrors.companyRefError = "Business Name is required.";
      }
    }
    if (selectedCountry.trim() === "") {
      newErrors.country = "Country is required.";
    }
    if (shareRef.current.value.trim() === "") {
      newErrors.share = "Ownership Percentage is required.";
    } else {
      const percentageValue = parseFloat(shareRef.current.value.trim());
      if (isNaN(percentageValue) || percentageValue <= 0 || percentageValue > 100) {
        newErrors.share = "Invalid percentage value. Must be between 0 and 100.";
      } else if (!indOwnership) {
        const remainingPercentage = 100 - totalPercentage;
        if (percentageValue > remainingPercentage) {
          newErrors.share = `Total shares percentage exceeds 100%. You can add up to ${parseFloat(remainingPercentage.toFixed(2))}%.`;
        }
      } else {
        const allowance = 100 - totalPercentage + parseFloat(indOwnership.percentage_of_shares_held || 0);
        if (percentageValue > allowance) {
          newErrors.share = `Total shares percentage exceeds 100%. You can allocate up to ${parseFloat(allowance.toFixed(2))}% for this owner.`;
        }
      }
    }
    setNameError(newErrors.name || "");
    setCompanyRefError(newErrors.companyRefError || "");
    setCountryError(newErrors.country || "");
    setShareError(newErrors.share || "");
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const verifiedData = currentEditingCompany.verifiedCompany;
    if (isVerified(verifiedData)) {
      if (indOwnership) {
        if (indOwnership?.ownership_ind_draftID) {
          if (indOwnership?.ownership_indID_id != undefined && indOwnership?.ownership_indID_id != null) {

            // alert("updateOwnershipIndividualDraft-1")
            await updateOwnershipIndividualDraft({
              data: {
                nationality: selectedCountry,
                type,
                percentage_of_shares_held: shareRef.current.value,
                name: type === "individual" ? nameRef.current.value : companyRef?.current?.value,
                ownershipCompany: CompanyOwnership,
                current_companyID: currentEditingCompany.companyID,
                request_type: "ownership individual draft created",
                ownership_indID: indOwnership?.ownership_indID,
              },
              ownershipdraftID: indOwnership?.ownership_ind_draftID,
              token,
            }).unwrap()
            reset()
            refetch();
            compRefetch();
            setDataChanged(!dataChanged);
            modalHandle();
          } else {
            // alert("updateOwnershipIndividualDraft-2")
            await updateOwnershipIndividualDraft({
              data: {
                nationality: selectedCountry,
                type,
                percentage_of_shares_held: shareRef.current.value,
                name: type === "individual" ? nameRef.current.value : companyRef?.current?.value,
                ownershipCompany: CompanyOwnership,
                current_companyID: currentEditingCompany.companyID,
                request_type: "ownership individual draft created",
              },
              ownershipdraftID: indOwnership?.ownership_ind_draftID,
              token,
            }).unwrap()
            reset()
            refetch()
            compRefetch();
            setDataChanged(!dataChanged)
            modalHandle();
          }

        } else if (indOwnership?.ownership_comp_draftID) {
          if (indOwnership?.ownership_compID_id != undefined && indOwnership?.ownership_compID_id != null) {
            // alert("updateOwnershipIndividualDraft-1")
            await updateOwnershipCompanyDetailsDraft({
              data: {
                nationality: selectedCountry,
                country: selectedCountry,
                state: selectedCompany?.state,
                type,
                percentage_of_shares_held: shareRef.current.value,
                company_name: type === "individual" ? nameRef.current.value : companyRef?.current?.value,
                ownershipCompany: CompanyOwnership,
                current_companyID: currentEditingCompany?.companyID,
                companyID: currentEditingCompany?.companyID,
                request_type: "Ownership Company Draft Created",
                ownership_compID: indOwnership?.ownership_compID,
              },
              ownershipdraftID: indOwnership?.ownership_comp_draftID,
              token,
            }).unwrap();
            reset()
            refetch();
            compRefetch();
            setDataChanged(!dataChanged)
            modalHandle();
          } else {
            // alert("updateOwnershipIndividualDraft-2")
            await updateOwnershipCompanyDetailsDraft({
              data: {
                nationality: selectedCountry,
                country: selectedCountry,
                state: selectedCompany?.state,
                type,
                percentage_of_shares_held: shareRef.current.value,
                company_name: type === "individual" ? nameRef?.current?.value : companyRef?.current?.value,
                ownershipCompany: CompanyOwnership,
                current_companyID: currentEditingCompany?.companyID,
                companyID: currentEditingCompany?.companyID,
                request_type: "Ownership Company Draft Created",
              },
              ownershipdraftID: indOwnership?.ownership_comp_draftID,
              token,
            }).unwrap();
            reset()
            refetch();
            compRefetch();
            setDataChanged(!dataChanged);
            modalHandle();
          }
        } else {
          try {
            let res;
            if (type === "individual") {
              // alert("createOwnershipIndividualDraft-1")
              res = await createOwnershipIndividualDraft({
                data: {
                  nationality: selectedCountry,
                  type,
                  percentage_of_shares_held: shareRef.current.value,
                  name: nameRef.current.value,
                  ownershipCompany: CompanyOwnership,
                  current_companyID: currentEditingCompany.companyID,
                  request_type: "ownership individual draft created",
                  ownership_indID: indOwnership?.ownership_indID,
                },
                token,
              }).unwrap();
            } else {
              let convertWINtoTRX = CompanyOwnership;

              if (!selectedCompany?.companyID && selectedCompany.win) {
                // Create the company and wait for the response
                const dataCompany = await createCompany({
                  data: {
                    wb_win: selectedCompany.win,
                    registered_company_name: selectedCompany.name,
                    country_code: selectedCompany.country,
                  },
                  token,
                }).unwrap();

                // Extract the new companyID
                const newCompanyID = dataCompany.data.companyID;

                // Update the state variable with the new companyID
                // setCompanyOwnership(newCompanyID);
                convertWINtoTRX = newCompanyID
                // alert("createOwnershipCompanyDetailsDraft-1: " + convertWINtoTRX)
              }

              // alert("createOwnershipIndividualDraft-1")
              res = await createOwnershipCompanyDetailsDraft({
                data: {
                  nationality: selectedCountry,
                  country: selectedCountry,
                  state: selectedCompany?.state,
                  type,
                  percentage_of_shares_held: shareRef.current.value,
                  company_name: indOwnership?.company_name,
                  ownershipCompany: convertWINtoTRX,
                  current_companyID: currentEditingCompany?.companyID,
                  companyID: currentEditingCompany?.companyID,
                  request_type: "Ownership Company Draft Created",
                  ownership_compID: indOwnership?.ownership_compID,
                },
                token,
              }).unwrap();
            }
            reset()
            refetch();
            compRefetch();
            setDataChanged(!dataChanged);
            modalHandle();
          } catch (error) {
          }

          return;
        }
      } else {
        try {
          let res;
          if (type === "individual") {
            // alert("createOwnershipIndividualDraft-2")
            res = await createOwnershipIndividualDraft({
              data: {
                nationality: selectedCountry,
                type,
                percentage_of_shares_held: shareRef.current.value,
                name: nameRef.current.value, // Since type is 'individual', we directly use nameRef.current.value
                ownershipCompany: CompanyOwnership,
                current_companyID: currentEditingCompany.companyID,
                request_type: "ownership individual draft created",
                ownership_indID: indOwnership?.ownership_indID,
              },
              token,
            }).unwrap();
          } else {
            let convertWINtoTRX = CompanyOwnership;

            if (!selectedCompany?.companyID && selectedCompany.win) {
              // Create the company and wait for the response
              const dataCompany = await createCompany({
                data: {
                  wb_win: selectedCompany.win,
                  registered_company_name: selectedCompany.name,
                  country_code: selectedCompany.country,
                },
                token,
              }).unwrap();

              // Extract the new companyID
              const newCompanyID = dataCompany.data.companyID;

              // Update the state variable with the new companyID
              // setCompanyOwnership(newCompanyID);
              convertWINtoTRX = newCompanyID
            }

            // alert("createOwnershipIndividualDraft-2")
            res = await createOwnershipCompanyDetailsDraft({
              data: {
                nationality: selectedCountry,
                country: selectedCountry,
                state: selectedCompany?.state,
                type,
                percentage_of_shares_held: shareRef.current.value,
                company_name: companyRef?.current?.value, // Since type is not 'individual', we use companyRef.current.value
                ownershipCompany: convertWINtoTRX,
                current_companyID: currentEditingCompany?.companyID,
                companyID: currentEditingCompany?.companyID,
                request_type: "Ownership Company Draft Created",
                ownership_compID: indOwnership?.ownership_compID,
              },
              token,
            }).unwrap();
          }
          reset()
          refetch();
          compRefetch();
          setDataChanged(!dataChanged);
          modalHandle();
        } catch (error) {
        }

        return;
      }
    }
    else {
      if (indOwnership) {
        try {
          let res;
          if (indOwnership?.ownership_indID) {
            // alert("updateOwnershipIndividual-1")
            res = await updateOwnershipIndividual({
              data: {
                nationality: selectedCountry,
                type,
                percentage_of_shares_held: shareRef.current.value,
                name: nameRef.current.value, // Using nameRef.current.value as this block is for individual ownership
                ownershipCompany: CompanyOwnership,
              },
              ownership_indId: indOwnership.ownership_indID,
              token,
            }).unwrap();
          } else {
            // alert("company update info: " + JSON.stringify(indOwnership)) //indOwnership
            // alert("updateOwnershipCompanyDetails-1")
            res = await updateOwnershipCompanyDetails({
              data: {
                nationality: selectedCountry,
                type,
                percentage_of_shares_held: shareRef.current.value,
                company_name: indOwnership?.company_name, // Using companyRef.current.value as this block is for company ownership
                ownershipCompany: indOwnership?.ownershipCompany,
              },
              ownership_compId: indOwnership?.ownership_compID,
              token,
            }).unwrap();
          }
          reset()
          refetch();
          compRefetch();
          setDataChanged(!dataChanged);
          modalHandle();
        } catch (error) {
        }
      }
      else {

        try {

          let res;
          if (type === "individual") {
            res = await individualOwnership({
              data: {
                nationality: selectedCountry,
                type,
                percentage_of_shares_held: shareRef.current.value,
                name: nameRef.current.value, // Since type is 'individual', we directly use nameRef.current.value
                ownershipCompany: CompanyOwnership,
              },
              token,
            }).unwrap();
          } else {

            let convertWINtoTRX = CompanyOwnership;

            if (!selectedCompany?.companyID && selectedCompany.win) {
              // Create the company and wait for the response
              const dataCompany = await createCompany({
                data: {
                  wb_win: selectedCompany.win,
                  registered_company_name: selectedCompany.name,
                  country_code: selectedCompany.country,
                },
                token,
              }).unwrap();

              // Extract the new companyID
              const newCompanyID = dataCompany.data.companyID;

              // Update the state variable with the new companyID
              // setCompanyOwnership(newCompanyID);
              convertWINtoTRX = newCompanyID
            }

            res = await createOwnershipCompanyDetailsMutation({
              data: {
                nationality: selectedCountry,
                state: selectedCompany?.state,
                country: selectedCountry,
                type,
                percentage_of_shares_held: shareRef.current.value,
                company_name: companyRef?.current?.value, // Since type is not 'individual', we use companyRef.current.value
                ownershipCompany: convertWINtoTRX,
              },
              token,
            }).unwrap();
          }

          if (res?.ownership_indID || res?.ownership_compID) {
            const resOwnership = await createOwnership({
              data: {
                ownership_indID: res?.ownership_indID,
                ownership_compID: res?.ownership_compID,
              },
              token,
            }).unwrap();

            if (resOwnership?.ownershipID) {
              const resOwnershipCompany = await ownershipCompany({
                data: {
                  ownershipID: resOwnership?.ownershipID,
                  companyID: currentEditingCompany?.companyID,
                },
                token,
              }).unwrap();
            }
          }
          reset()
          refetch();
          compRefetch();
          setDataChanged(!dataChanged);
          modalHandle();
        } catch (error) {
        }
      }
    }

  };

  const goToSearch = () => {
    onSearch(selectedCountry, shareRef.current.value);
    showForm();
  };

  useEffect(() => {
    if (selectedCompany) {
      if (companyRef.current) {
        companyRef.current.value = selectedCompany?.name || selectedCompany?.registered_company_name || indOwnership?.registered_company_name || "";
      }
      setCompanyOwnership(selectedCompany?.companyID || indOwnership?.ownershipCompany || selectedCompany?.win)
      setSelectedOwnershipCompany(selectedCompany);
    }
  }, [selectedCompany, setCompanyOwnership, selectedOwnershipCompany]);

  return (
    <Card classes="rounded bg-white p-4 w-[34rem]">
      <h5 className="text-f18 text-secondarytwo text-left mb-4">
        Add New Ownership
      </h5>

      <div className="">

        <Select
          label="Type"
          id="type"
          value={type}
          placeholder="Select a Type"
          onChange={handleTypeChange}
          disable={Boolean(indOwnership)}
        >
          <option value="company">Business</option>
          <option value="individual">Individual</option>
        </Select>
        {
          !indOwnership && type == 'company' ?
            <> {!selectedCompany && (
              <Button
                onClick={goToSearch}
                classes={`w-full text-left border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 block `}
              >
                Search Business
              </Button>
            )}
              <input
                label="Business Name"
                id="name"
                ref={companyRef}
                placeholder="Search Business"
                className={`w-full border focus:border-primary px-3 py-2 border-input rounded bg-inputDisable mb-4 ${selectedCompany ? "block" : "hidden"
                  }`}
                error={companyRefError}
                readOnly={Boolean(companyRef) || Boolean(indOwnership)}

              /></> :
            <Input
              // className={Boolean(indOwnership) && "disableInput"}
              label={type == 'company' ? "Business Name" : "Name"}
              id="name"
              inputRef={nameRef}
              error={nameError}
              placeholder="Enter"
            // readOnly={Boolean(indOwnership)}
            />
        }

        <Select
          label="Country"
          id="country"
          value={selectedCountry}
          error={countryError}
          placeholder="Select a country"
          onChange={handleCountryChange}
          disable={type !== 'individual' && (previsousCountry !== null || selectedCompany?.country !== undefined || selectedCompany?.country_code !== undefined || indOwnership?.nationality) ? true : false}
        >
          <option value="" disabled={true}>Select a country</option>
          {countries
            .sort((a, b) => a.countryName.localeCompare(b.countryName))
            .map((country, index) => (
              <option key={index} disabled={(previsousCountry !== null || selectedCompany?.country !== undefined || selectedCompany?.country_code !== undefined || indOwnership?.nationality) ? true : false} value={country.countryCode}>
                {country.countryName}
              </option>
            ))}
        </Select>
        <Input
          label={`Ownership Percentage - ${parseFloat((100 - totalPercentage).toFixed(2))}% Remaining`}
          id="share"
          inputRef={shareRef}
          error={shareError}
          placeholder="Enter"
        />

        <Button
          onClick={handleSubmit}
          classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex items-center justify-center "
        >
          {isLoading || companyLoading || isUpdating || comUpdating ? (
            <Spinner />
          ) : (
            "Save"
          )}
        </Button>
      </div>
    </Card>
  );
};
